import { WonderschoolPlanModal } from '@wonderschool/ccms-ui';
import { FoodProgramQueryProvider } from '@wonderschool/common-food-program-ui';
import { useCallback } from 'react';
import WSA from '../../WSA';
import { getCurrentEnvironment } from '../../common/utils/environmentUtils';
import useOrganizationImpersonation from '../../hooks/useOrganizationImpersonation';
import { useAuthToken } from '../../hooks/useUser';

interface ApolloClientWrapperProps {
  children: React.ReactNode | React.ReactNode[];
}

export function ApolloClientWrapper({ children }: ApolloClientWrapperProps) {
  const { isAuthenticated, authUser } = WSA.Components.useWSAuth();
  const { impersonatedToken } = useAuthToken();
  const currentEnvironment = getCurrentEnvironment();
  const { isImpersonatingOrganization } = useOrganizationImpersonation();

  // Memoize getAuthToken to prevent Apollo Client from being recreated on every render
  const getAuthToken = useCallback(async (): Promise<string> => {
    if (impersonatedToken) {
      return impersonatedToken;
    }
    const token = await authUser?.getIdToken();
    return token || '';
  }, [impersonatedToken, authUser]);

  if (!isAuthenticated || !authUser) {
    return children;
  }

  return (
    <FoodProgramQueryProvider getAuthToken={getAuthToken} environment={currentEnvironment}>
      <>
        {!isImpersonatingOrganization && <WonderschoolPlanModal />}
        {children}
      </>
    </FoodProgramQueryProvider>
  );
}
